import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import Dialog from 'components/dialog';
import { useServiceModeContext } from 'state/service-mode';
import { primitive } from 'styles/constants/primitives';

import { ChangeStoreConfirmationDialogProps } from './types';

const messages = {
  delivery: {
    buttonLabel: {
      id: 'changeRestaurantDialogConfirmButtonLabelDelivery',
      defaultMessage: 'Change Address',
    },
    headerText: {
      id: 'changeRestaurantDialogHeadingDelivery',
      defaultMessage: 'Change Address?',
    },
    bodyText: {
      id: 'changeRestaurantDialogBodyDelivery',
      defaultMessage:
        'Changing your address may result in differences in prices or item availability.',
    },
  },
  pickup: {
    buttonLabel: {
      id: 'changeRestaurantDialogConfirmButtonLabel',
      defaultMessage: 'Change Restaurant',
    },
    headerText: {
      id: 'changeRestaurantDialogHeading',
      defaultMessage: 'Change Restaurant',
    },
    bodyText: {
      id: 'changeRestaurantDialogBody',
      defaultMessage:
        'Changing your restaurant may result in differences in prices or item availability.',
    },
  },
};

export const ChangeStoreConfirmationDialog = ({
  onDismiss,
  onConfirm,
  showDialog,
}: ChangeStoreConfirmationDialogProps) => {
  const { formatMessage } = useIntl();
  const { isDelivery } = useServiceModeContext();

  const messageSet = isDelivery ? messages.delivery : messages.pickup;
  const buttonLabel = formatMessage(messageSet.buttonLabel);
  const headerText = formatMessage(messageSet.headerText);
  const bodyText = formatMessage(messageSet.bodyText);

  return (
    <Dialog
      showDialog={showDialog}
      headingComponent={
        <View style={styles.dialogHeaderContainer}>
          <Icon variant="errorFill" size="$11" />
          <Text style={styles.dialogHeaderText}>{headerText}</Text>
        </View>
      }
      bodyComponent={<Text style={styles.dialogBodyText}>{bodyText}</Text>}
      confirmButtonLabel={buttonLabel}
      confirmDialog={onConfirm}
      onDismiss={onDismiss}
      modalAppearanceEventMessage="Change Store Confirmation from Checkout"
      isErrorModal
      showCloseButton
    />
  );
};

const styles = StyleSheet.create({
  dialogHeaderText: {
    fontFamily: primitive.fontFamily.$headers,
    fontSize: 16,
    marginTop: 8,
    textAlign: 'center',
    color: primitive.bk.$bbqBrown,
  },
  dialogHeaderContainer: {
    alignItems: 'center',
  },
  dialogBodyText: {
    fontFamily: primitive.fontFamily.$body,
    textAlign: 'center',
    marginVertical: 12,
    color: primitive.bk.$bbqBrown,
  },
});
